import { Skeleton } from 'antd'
import React from 'react'
import styled from 'styled-components'

interface FilterOptionPostCountCellProps {
  nPosts: number | undefined
}

const CountText = styled.span`
  font-size: 12px;
  color: #6b7280;
`

const LoadingWrapper = styled(CountText)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

const NumberSkeleton = styled(Skeleton.Button)`
  &.ant-skeleton.ant-skeleton-element {
    width: 32px;
    min-width: 32px;
    line-height: 1;
  }
  &.ant-skeleton.ant-skeleton-element .ant-skeleton-button {
    width: 32px;
    min-width: 32px;
    height: 12px;
  }
`

/**
 * Right-hand "<N> posts" cell on a filter-option row in the charts-v2
 * "+ Filter" popover. When the per-panel `/filter/options/v2` fetch has
 * not yet produced a count for this value, `nPosts` is `undefined`
 * (the `stripFilterCounts` fallback strips it) and we render an
 * animated Antd Skeleton.Button sized like a 3-4 digit number, paired
 * with the literal " posts" suffix so the row layout matches the
 * populated state and signals "<N> posts will land here." Once a count
 * is available — including the boundary value `0` — we render the
 * locale-formatted "<N> posts" text.
 */
export const FilterOptionPostCountCell: React.FC<
  FilterOptionPostCountCellProps
> = ({ nPosts }) =>
  nPosts !== undefined ? (
    <CountText>{`${nPosts.toLocaleString()} posts`}</CountText>
  ) : (
    <LoadingWrapper>
      <NumberSkeleton active size="small" />
      {' posts'}
    </LoadingWrapper>
  )
